import SecurityPanelContent from './SecurityPanelContent';

export default SecurityPanelContent;
